import React, { useState, useEffect } from 'react'; 
import { Link } from "react-router-dom";
import CookiesPolicy from '../../policy/cookiepolicy';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';

export default function AdminFooter() {

    // state declaration
    const [poliicyModalShow, setPoliicyModalShow] = useState(false);
    const currentYear = moment.utc().format('YYYY');

    useEffect(() => {
        const scriptSrc = "https://cdn.termsfeedtag.com/plugins/pc/v1/404891cc715341f7946d05a5b4a8425b/plugin.js";

        if (document.querySelector(`script[src="${scriptSrc}"]`)) {
            return;
        }

        const script = document.createElement("script");

        script.src = scriptSrc;
        script.async = true;

        document.body.appendChild(script);
    }, []);

    return(
        <section className='adminStylist admin-footer'>
            <div className='footer'>
                <div className='container'> 
                    <Row>
                        <Col md={9}>
                            <p>© {currentYear} Unext. All rights reserved | <Link to="/termsconditions" state={{ returnUrl: "/admin/dashboard" }}> Terms and Conditions</Link> | <Link onClick={() => setPoliicyModalShow(true)}>Cookie Policy</Link> | <span id='open_privacy_preferences_element' style={{textDecoration : 'underline', cursor : 'pointer'}}>Privacy Preference</span> | <span id='open_dnsmpi_element' style={{textDecoration : 'underline', cursor : 'pointer'}}>Do Not Sell My Personal Informationn</span></p>
                            <p>Developed and Supported by <a href="https://www.datanetiix.com/" className="dnx-link" target="_blank"> Datanetiix Solutions Inc.,</a></p>            
                        </Col>
                    </Row>
                </div>
            </div> 
            <CookiesPolicy show={poliicyModalShow} onHide={() => setPoliicyModalShow(false)} />

            {/* <Link onClick={privacyStatus === true ? () => privacyFalseHandler() : () => privacyTrueHandler()}>Privacy Preference </Link> */}
        </section>
    )
}